import Fingerprint2 from "fingerprintjs2"

export default function FingerprintComponent(app)
{

    window.Fingerprint2 = Fingerprint2

    /**
     * Helper function for setting the fingerprint
     *
     * @return void
     */

    function setFinterprint()
    {
        let fingerprintInput = document.querySelector('input[name=fingerprint]')
        if(fingerprintInput) {
            Fingerprint2.get( function(components, result){
                fingerprintInput.value = Fingerprint2.x64hash128(components.map(function(pair){return pair.value}).join(), 31)
            })
        }
    }

    if(window.requestIdleCallback) {
        setFinterprint()
    } else {
        setTimeout(setFinterprint, 500)
    }

}
